// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"logs-placeholder__wrap--1IHwS","fadeIn":"logs-placeholder__fadeIn--3D-E9","img":"logs-placeholder__img--1-iwx","caption":"logs-placeholder__caption--3Fad0"};